import { render, staticRenderFns } from "./InventoryReadList.vue?vue&type=template&id=2b141b22"
import script from "./InventoryReadList.vue?vue&type=script&lang=js"
export * from "./InventoryReadList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports